import _ from 'lodash'
import {
  STORE_RECENT_SAVED_PROPERTIES,
  STORE_SAVED_PROPERTY_IDENTIFIERS,
  APPEND_SAVED_PROPERTY,
  SPLICE_SAVED_PROPERTY,
} from '../constants/actionTypes'

// TODO this whole reducer is now acting as the saved properties identifiers reducer, once we move away from redux we can remove this and completely rely on useSavedProperties hook
const initialState = {
  /**
   * A list of recent properties the user saved -- for use in the UI
   */
  recentSavedAssets: [],

  /**
   * A list of ids of the properties users have already saved
   */
  savedAssetsIdentifiers: [],
}

export default function propertyReducer(state = initialState, action) {
  switch (action.type) {
    case STORE_SAVED_PROPERTY_IDENTIFIERS:
      return _.merge({}, state, {
        savedAssetsIdentifiers: action.identifiers || [],
      })

    case STORE_RECENT_SAVED_PROPERTIES:
      return _.merge({}, state, {
        recentSavedAssets: action.properties || [],
      })

    case APPEND_SAVED_PROPERTY: {
      const id = action.property.property_id

      return _.merge({}, state, {
        savedAssetsIdentifiers: [...state.savedAssetsIdentifiers, String(id)],
        recentSavedAssets: [...state.recentSavedAssets, action.property],
      })
    }
    case SPLICE_SAVED_PROPERTY: {
      const savedAssetsIdentifiers = state.savedAssetsIdentifiers.filter(
        id => Number(id) !== Number(action.id)
      )
      const recentSavedAssets = state.recentSavedAssets.filter(property => {
        const id = property.property_id
        return Number(id) !== Number(action.id)
      })
      return {
        ...state,
        savedAssetsIdentifiers,
        recentSavedAssets,
      }
    }

    default:
      return state
  }
}

export { initialState }
